import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { VariantDTO } from './dto/item-variant.dto';
import {VariantResponseModel, AllVariantResponseModel,VariantStatusWiseResponseModel,VariantDto} from '@gtpl/shared-models/masters';
import {ApplicationExceptionHandler, errorHandler} from '@gtpl/shared-utils/error-messages';

import { VariantService } from './item-variant.service';
@ApiTags('Item-Variant')
@Controller('Item-Variant')
export class VariantController {
  constructor(private variantService: VariantService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {}

  @Post('/createVariant')
  async createVariant(@Body() variantDto:VariantDTO,isUpdate:boolean=false,
  ): Promise<VariantResponseModel> {
  try {
      return await this.variantService.createVariant(variantDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VariantResponseModel, error);
    }
  }

  @Post('/updateVariant')
  async updateState(@Body() variantDto: VariantDTO): Promise<VariantResponseModel> {
    try {
      console.log('update variant');
      return await this.variantService.createVariant(variantDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VariantResponseModel, error);
    }
  }

  @Post('/getAllVariants')
  // @UseGuards(AuthGuard('jwt'))
  async getAllVariants(): Promise<AllVariantResponseModel> {
    try {
      return await this.variantService.getAllVariants();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllVariantResponseModel, error);
    }
  }
  @Post('/updateVariantStatus')
  async updateStateStatus(@Body() variantDto: VariantDTO): Promise<VariantResponseModel> {
    try {
      return await this.variantService.createVariant(variantDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VariantResponseModel, error);
    }
  }
  @Post('/getAllActiveVariants')
  async getAllActiveVariants(): Promise<AllVariantResponseModel> {
    try {
      return await this.variantService.getAllActiveVariants();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllVariantResponseModel, error);
    }
  }
  @Post('/getActiveVariantCount')
  async getActiveVariantsCount(): Promise<VariantStatusWiseResponseModel> {
    try {
      return await this.variantService.getActiveVariantsCount();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(VariantStatusWiseResponseModel, error);
    }
  }
}
